import React from "react";
import { Tag } from "antd";

type Props = React.ComponentProps<typeof Tag>;

export default function V2Tag(props: Props) {
    const { style, color, ...rest } = props;
    const normalized = String(color || "").toLowerCase();
    const isGreen = normalized === "green";
    const isGray = !normalized || normalized === "default";
    const isYellow = normalized === "gold" || normalized === "yellow";
    const isBlueish = normalized === "blue" || normalized === "cyan";
    return (
        <Tag
            {...((isGreen || isGray || isYellow || isBlueish) ? {} : { color })}
            {...rest}
            style={{
                border: "none",
                fontFamily: "quicksand-bold",
                fontSize: 14,
                padding: "2px 6px",
                ...(isGreen ? { background: "#e5ffe5", color: "#60b571" } : {}),
                ...(isGray ? { background: "#f2f2f2", color: "#b5b5b5" } : {}),
                ...(isYellow ? { background: "#fff6e0", color: "#cbb17a" } : {}),
                ...(isBlueish ? { background: "rgb(229 241 255)", color: "rgb(141 160 210)" } : {}),
                ...(style || {}),
            }}
        />
    );
}
